const config = {
    ssoUrl: window.APP_CONFIG.SSO_URL,
    omrehBaseUrl: window.APP_CONFIG.OMREH_BASE_URL,
};

export default config;